import {
  OrganizationTemplateRubric,
  Template,
  TemplateRubricName,
} from "features/Influencer/ContactList/schema";

export const calculateScore = (rubric: OrganizationTemplateRubric): number => {
  return Math.round((rubric.userScore / rubric.totalScore) * 100);
};

export const getScoreColor = (value: number) => {
  if (value < 30)
    return { filled: "#F44336", track: "#FEECEB", text: "#C62828" };
  if (value < 70)
    return { filled: "#FFA726", track: "#FFF3E0", text: "#E65100" };
  return { filled: "#94EB9A", track: "#F2FCF2", text: "#2E7D32" };
};

export const getScoreLabel = (value: number) => {
  if (value >= 70) return "Your template is ready to send!";
  if (value >= 30) return "Your template needs some tweaks.";
  return "Your template needs improvement.";
};

export const getLatestRubricByName = (
  rubricName: TemplateRubricName,
  template: Template,
) => {
  const matching = template.rubrics?.filter((r) => r.name === rubricName) ?? [];
  return matching.reduce<OrganizationTemplateRubric | null>(
    (latest, r) =>
      latest === null || r.createdAt > latest.createdAt ? r : latest,
    null,
  );
};
